<template>
  <div class="container">
    <div class="row mt-2 mt-lg-4 justify-content-center align-items-center">
      <div class="col-6 col-lg-2">
        <div class="payment-logo">
          <a href="/">
            <img src="@/assets/amej-pay.png" alt="Amejpay" />
          </a>
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <h2
          class="text-bold text-center"
          v-if="merchant_payment_details.merchant_account_detail"
        >
          {{ merchant_payment_details.merchant_account_detail.company_name }}
        </h2>
      </div>
    </div>

    <div class="row m-0 justify-content-center">
      <div class="col-12">
        <PaymentTab
          :metchantdata="merchant_payment_details"
          :transactionid="transactionid"
        ></PaymentTab>
      </div>
    </div>
    <b-modal
      ref="loader_modal"
      id="loader_modal"
      class="loader_modal"
      size="sm"
      text-center
      headerClass="border-bottom-0"
      centered
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
    >
      <div class="text-center p-4">
        <b-spinner variant="light" label="Text Centered"></b-spinner>
      </div>
    </b-modal>

    <b-toast
      id="error-toast"
      variant="danger"
      solid
      append-toast
      toaster="b-toaster-top-center"
    >
      <div slot="toast-title" class="d-flex flex-grow-1 align-items-baseline">
        <strong class="mr-auto">Error!!!</strong>
      </div>
      <div
        class="text-danger"
        v-for="(error, index) in errors.auth"
        :key="index"
      >
        {{ error }}
      </div>
    </b-toast>
    <Footer></Footer>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import PaymentTab from "./PaymentTab.vue";
import Footer from "../../reuseable_components/Footer";

// const axios = require("axios");
export default {
  components: {
    PaymentTab,
    Footer,
  },
  name: "",
  data() {
    return {
      username: "",
      password: "",
      text: "Login Form",
      available: false,
      show: false,
      errors: { auth: [] },
      disabledLogin: true,
      transactionid: this.$route.params.transactionid,
    };
  },
  created() {
    this.getMerchantPaymentDetailByTransactionId(this.transactionid);
  },
  computed: {
    ...mapState([
      "successmessage",
      "errormessage",
      "message",
      "merchant_payment_details",
    ]),
  },
  mounted() {
    if (this.transactionid == "") {
      // Guard: state may not be loaded yet (initializes as []), so read defensively
      let detail =
        this.merchant_payment_details &&
        this.merchant_payment_details.merchant_payment_detail;
      if (detail && detail.failure_url) {
        let reloadUrl =
          detail.failure_url + "?status=fail&transaction_key=";
        window.open(reloadUrl, "_self");
      }
    } else {
      // eslint-disable-next-line no-console
      window.localStorage.setItem("token", "");
      this.setToken("");
    }
  },
  methods: {
    ...mapActions(["getMerchantPaymentDetailByTransactionId"]),
    ...mapMutations(["setToken"]),
  },
};
</script>
<style lang="scss" scoped>
@import "../../../css/style.scss";
</style>
